var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrendGraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.727083 0C1.12864 0 1.45417 0.325526 1.45417 0.727083V8.42383L3.30306 6.57494C4.08895 5.78905 5.36313 5.78905 6.14902 6.57494C6.36702 6.79294 6.72048 6.79294 6.93848 6.57494L8.63679 4.87662C9.48862 4.02479 10.8697 4.0248 11.7215 4.87663L12.1475 5.30254C12.4314 5.58649 12.4314 6.04685 12.1475 6.33079C11.8635 6.61474 11.4032 6.61474 11.1192 6.33079L10.6933 5.90488C10.4093 5.62093 9.94899 5.62093 9.66504 5.90488L7.96673 7.60319C7.18084 8.38908 5.90666 8.38908 5.12077 7.60319C4.90277 7.38519 4.54932 7.38519 4.33131 7.60319L1.45417 10.4803V10.9063C1.45417 11.3078 1.77969 11.6333 2.18125 11.6333H12.3604C12.762 11.6333 13.0875 11.9589 13.0875 12.3604C13.0875 12.762 12.762 13.0875 12.3604 13.0875H2.18125C0.976579 13.0875 0 12.1109 0 10.9063V0.727083C0 0.325526 0.325526 0 0.727083 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendGraph);
export default __webpack_public_path__ + "static/media/trend-graph.082e528e7e63cd05eccab3fb0cc09c5f.svg";
export { ForwardRef as ReactComponent };